import { Box, Button, Modal } from "@mui/material";
import React, { FC } from "react";
import { ISKUMassUploadResponse } from "../pages/consolidated/interfaces/sku";

const style = {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    minWidth: '35vw',
    maxHeight: '64vh',
    bgcolor: 'background.paper',
    border: '2px solid FFFFFF',
    boxShadow: 24,
    borderRadius: '8px',
    p: '1.5vh 3vh',
    overflow: 'auto',
};

type IProps = {
    open: boolean;
    data: ISKUMassUploadResponse | null;
    handleDialogueBox: () => void;
}

const SKUExclusionNewlistDelistMassuploadresultsDialogBox:FC<IProps> = ({
    open,
    data,
    handleDialogueBox
}) => {
    return (
        data
            ? <Modal
                open={open}
                onClose={handleDialogueBox}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style} position="absolute">
                    {data?.total_added > 0 && 
                        <div className="brand-category-dialogue-box-description w-100 mb-4">
                            <p className="fw-bolder text-start">{`${data.total_added} item${data.total_added > 1 ? 's were' : ' was'} added successfully.`}</p>
                        </div>
                    }
                    {data?.items_failed?.length > 0 && 
                        <div className="brand-category-dialogue-box-description w-100">
                            <p className="text-start fw-bolder mb-1">Errors:</p>
                            {data.items_failed.map((item, i) => (
                                <p className="text-start mb-0" key={`${i}_${item.item.ban_number}`}>
                                    {`Item ${item.item.ban_number}: ${Object.values(item.reason).join(' ')}`}
                                </p>
                            ))}
                        </div>
                    }
                    <div className="brand-category-dialogue-button-container mt-4">
                        <Button
                            className="brand-category-dialogue-button-submit"
                            onClick={handleDialogueBox}
                        >
                            Ok
                        </Button>
                    </div>
                </Box>
            </Modal>
            : <></>
        
    );
}

export default SKUExclusionNewlistDelistMassuploadresultsDialogBox;